import { ICollectionState } from '@lib/context/brand-detail-collection-context'

export const BRAND_LIMIT = 4

export enum AZFilter {
  AZ = 'A-Z',
  ZA = 'Z-A'
}

export const BRAND_SANITY_NAME = 'brand'

export const COLLECTION_ALL_IN_BRAND = (ids: string[]): ICollectionState => {
  return {
    title: 'All',
    type: 'brand',
    ids
  }
}
